import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { Box } from '@mui/material';

export type DropDownItem = { key: string; value: string };

interface DropDownFilterProps {
  selectedValue?: string;
  optionValues: DropDownItem[];
  columnsSelectRef?: React.RefObject<HTMLSelectElement>; //what does this do?
  searchFieldChangeHandler: (event: SelectChangeEvent<string>, child: React.ReactNode) => void;
}

export default function DropDownFilter(props: DropDownFilterProps) {
  return (
    <div
      style={{
        position: 'relative',
        display: 'inline-block',
      }}
    >
      <div style={{ borderRadius: '24px' }}>
        <Box component="form" noValidate>
          <FormControl sx={{ minWidth: 144, height: 42, borderRadius: 24 }}>
            <Select
              inputRef={props.columnsSelectRef}
              onChange={props.searchFieldChangeHandler}
              value={props.selectedValue}
              displayEmpty
              inputProps={{ 'aria-label': 'Without label' }}
              style={{ borderRadius: '24px', height: '42px' }}
              MenuProps={{
                PaperProps: {
                  sx: {
                    borderRadius: '24px',
                  },
                },
              }}
            >
              <MenuItem disabled value="">
                Select Filter
              </MenuItem>
              {props.optionValues.map((option: any) => (
                <MenuItem value={option.key} key={option.key}>
                  {option.value}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </div>
    </div>
  );
}
